<template>
    <div class="card-container">
        <common-top-form
            selectShowPower="/lklexamine/select"
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            :show="false"
        >
            <el-form-item label="商户号">
                <el-input
                    v-model="formModel.merNo"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="formModel.status">
                    <el-option
                        v-for="item in status"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    range-separator="至"
                    :clearable="true"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column
                prop="merNo"
                label="商户号"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="startDate"
                label="开始日期"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="endDate"
                label="结束日期"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="status"
                label="状态"
                :formatter="formatStatus"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="realityTransactions"
                label="达标交易量"
                min-width="260"
                show-overflow-tooltip
                :formatter="formatterTableNumber"
            ></el-table-column>
            <el-table-column
                prop="qualifiedTransactions"
                label="实际交易量"
                min-width="260"
                show-overflow-tooltip
                :formatter="formatterTableNumber"
            ></el-table-column>
            <el-table-column
                fixed="right"
                prop="createTime"
                label="时间"
                min-width="160"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import TransactionService from "service/TransactionService";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "couponinfo",
        components: {
            CommonTopForm,
            CommonTable,
        },
        data() {
            return {
                formModel: {
                    merNo: "",
                    status: "",
                    time: "",
                },
                status:[{
                    dictKey: '',
                    dictValue: '全部'
                },{
                    dictKey: '0',
                    dictValue: '考核中'
                },{
                    dictKey: '1',
                    dictValue: '成功'
                },{
                    dictKey: '2',
                    dictValue: '失败'
                },],
                tableData: [],
                submitService: TransactionService.lklexaminelist,
                params: {},
                page: {},
                isPage: false,
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.load();
        },
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == "") {
                    this.formModel.time = [];
                }
                const params = {
                    merNo: this.formModel.merNo,
                    status: this.formModel.status,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.formModel.time.length) {
                    params.startDate = this.formModel.time[0];
                    params.endDate = this.formModel.time[1];
                }
                return params;
            },
            ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
        },
        methods: {
            load() {
                this.formModel = {
                    time: "",
                };
                this.page = this.$refs.commonTable.page;
                this.getList();
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
            formatStatus(row, column, cellValue) {
                let value = "";
                this.status.forEach((item) => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value ? value : "--";
            },
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/LKLExamine.vue